import { useState } from 'react';
import PageTransition from '../components/PageTransition';
import ScrollReveal from '../components/ScrollReveal';
import ProjectCard from '../components/ProjectCard';
import { projects, categories } from '../data/projects';
import { useSEO } from '../hooks/useSEO';
import { PAGE_SEO } from '../utils/seo';

export default function WorkPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  // Apply SEO
  useSEO(PAGE_SEO.work);

  const filteredProjects =
    activeCategory === 'All'
      ? projects
      : projects.filter((p) => p.category === activeCategory);

  return (
    <PageTransition>
      <section className="section">
        <div className="container">
          <h1 className="h-1" style={{ marginBottom: 'var(--space-8)' }}>
            Work
          </h1>

          {/* Category Filters */}
          <ScrollReveal>
            <div className="filter-pills" role="tablist" aria-label="Filter projects by category">
              {categories.map((cat) => (
                <button
                  key={cat}
                  role="tab"
                  aria-selected={activeCategory === cat}
                  className={`filter-pill pill${activeCategory === cat ? ' filter-pill--active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </ScrollReveal>

          {/* Projects Grid */}
          <ScrollReveal delay={100}>
            {filteredProjects.length > 0 ? (
              <div className="grid-3" style={{ marginTop: 'var(--space-8)' }}>
                {filteredProjects.map((project, i) => (
                  <ProjectCard key={project.id} project={project} index={i} />
                ))}
              </div>
            ) : (
              <div className="empty-state" style={{ marginTop: 'var(--space-12)', textAlign: 'center' }}>
                <p className="body" style={{ color: 'var(--text-secondary)' }}>
                  No projects found in this category.
                </p>
              </div>
            )}
          </ScrollReveal>
        </div>
      </section>
    </PageTransition>
  );
}
